import profileUrl from "../../assets/icons/profile.svg";

export default function ProfileIcon({ size = 20, className = "" }) {
  return (
    <img
      src={profileUrl}
      alt=""
      className={className}
      width={size}
      height={size}
      aria-hidden="true"
      style={{
        display: "inline-block",
        verticalAlign: "middle",
        objectFit: "contain",
      }}
    />
  );
}
